<template lang="pug">
    .fis-express-billing-section
        .biller-cards-container(v-if="billing.valid && cards.length")
            .biller-card(v-for="card in cards" :class="{ selected: card.id == selectedCardId }")
                re-radio(name="billerCard" :radio-value="card.id" v-model="selectedCardId")
                    img.biller-card__logo(:src="cardLogoUrl(card)" :alt="card.brand")
                    .biller-card__data
                        .biller-card__number **** **** **** {{ card.last4 }}
                        .biller-card__brand {{ card.brand }}
            .biller-card.biller-card--different(:class="{ selected: !selectedCardId }")
                re-radio(name="billerCard" :radio-value="null" v-model="selectedCardId")
                     .biller-card__different Use a different card

        template(v-if="showPaymentIframe")
            .re-inp-box.re-input-use-user-data(v-show="enableStoredCards && !selectedCardId")
                re-checkbox(v-model="saveCard")
                    span Save this card for quicker checkout on future purchases.

            .re-cart-billing-edit-box(v-show="!selectedCardId")
                p Please fill in your billing details in the form below.
                iframe(ref="paymentIframe" :src="transactionSetup.url" height="700") Your browser does not support inline frames.

        .loader-container(v-if="loadingPaymentFrame")
            .loader

</template>

<script>
import { getItemLocation } from 'utils/vue/mixins/cart/location'

export default {
    name: 're-cart-billing-section-fis-express',

    props: {
        billing: {
            type: Object,
        },
    },

    data: () => ({
        loadingPaymentFrame: true,
        showPaymentIframe: false,
        transactionSetup: null,
        returnUrl: `${window.addiesaas.url}/fis-express/transaction/return`,
        cards: [],
        selectedCardId: null,
        saveCard: false,
        locationId: null,
        enableStoredCards: false,
    }),

    computed: {
        fields() {
            return this.billing.fields
        },
        costDetails() {
            return this.billing.costDetails
        },
    },

    async created() {
        this.enableStoredCards = this.billing.$options.$$s('enableStoredCards', false)

        const user = this.$store.getters.authUser
        const billingFields = this.billing.fields
        this.fields.first_name = user ? user.first_name : billingFields.first_name
        this.fields.last_name = user ? user.last_name : billingFields.last_name

        const items = Object.values(this.$store.getters['Shop/Orders/Cart/cartItems']).map(x => x.payload)
        const locationPaths = ['location_id']
        const item = _.find(items, item => !!getItemLocation(item, locationPaths))
        if (item) {
            this.locationId = getItemLocation(item, locationPaths)
        }
    },

    async mounted() {
        this.billing.disableSubmitButton = true

        if (this.enableStoredCards && this.$store.getters.authUser) {
            try {
                const { data: { data: cards } } = await axios.get(`${window.addiesaas.url}/api/customer/biller/card`)

                this.cards = cards.filter(c => c.location_id == this.locationId)

                const primaryCard = this.cards.find(card => card.is_primary)
                if (primaryCard) {
                    this.selectedCardId = primaryCard.id
                    this.loadingPaymentFrame = false
                }
            } catch {}
        }

        this.$nextTick(() => {
            this.mountPaymentForm()
        })
    },

    beforeDestroy() {
        console.log('re-cart-billing-section-fis-express: beforeDestroy')
        this.billing.disableSubmitButton = false

        this.billing.setCartValid()
        this.billing.setValidationError(null)

        window.removeEventListener('message', this.receivePaymentFormMessage, false)
    },

    watch: {
        selectedCardId() {
            this.billing.disableSubmitButton = !this.selectedCardId

            if (this.selectedCardId) {
                const card = this.cards.find(card => card.id == this.selectedCardId)

                this.billing.paymentCardExtra.saved_card_id = this.selectedCardId

                this.fields.card = `${card.bin}000000${card.last4}`
                this.fields.card_brand = card.brand
                this.fields.cvv = '000'
                this.fields.expMonth = card.expiry_year
                this.fields.expYear = card.expiry_month

                this.fields.country = 'NA'
            }
        },
    },

    methods: {
        async mountPaymentForm() {
            const { data: transactionSetup } = await axios.post(
                `${window.addiesaas.url}/api/customer/fis-express/transaction/setup`,
                {
                    amount: this.costDetails.total,
                    redirect: this.returnUrl + '?location=' + this.locationId,
                },
                {
                    headers: {
                        'X-Location': this.locationId,
                    }
                }
            )

            this.transactionSetup = transactionSetup

            this.showPaymentIframe = true

            this.loadingPaymentFrame = false

            window.addEventListener('message', this.receivePaymentFormMessage, false)
        },

        async receivePaymentFormMessage(event) {
            console.log('receivePaymentFormMessage', event)
            if (event.origin == (new URL(this.returnUrl)).origin) {
                console.log(event.data)

                if (event.data.cancelled) {
                    this.goBack()
                    return
                }

                if (event.data.error) {
                    this.billing.setCartInvalid()
                    this.billing.setValidationError(event.data.display_error || window.addiesaas.config.translations.fisexpress.transaction_not_authorized)
                } else {
                    if (event.data.transaction_id) {
                        this.billing.paymentTransactionId = event.data.transaction_id
                        this.billing.paymentCardExtra.transaction_id = event.data.fis_transaction_id
                        this.billing.paymentCardExtra.saved_card_id = null

                        if (this.saveCard) {
                            this.billing.paymentCardExtra.save_card = true;
                        }

                        const card = event.data.details.card
                        this.fields.card = card.cc_number.replaceAll('X', '0')
                        this.fields.card_brand = null
                        this.fields.cvv = '000'
                        this.fields.expMonth = card.cc_expiration_year
                        this.fields.expYear = card.cc_expiration_month

                        this.fields.country = 'NA'

                        await this.billing.submit()
                    }
                }

                this.showPaymentIframe = false
            }
        },

        goBack() {
            this.billing.setCartValid()
            this.billing.setValidationError(null)
            this.billing.goBack()
        },

        cardLogoUrl(card) {
            const brandMinified = card.brand.replaceAll(/\s+/g, '').toLowerCase()
            return `${window.addiesaas.config.baseUri}/pay-biller-fis-express/images/biller-card-${brandMinified}.png`
        },
    }
}
</script>
